<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Account Ledger"
              bc1="App"
              bc2="Ledger"
              bc3="List"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class=" d-flex justify-content-end">
            <div class="col-md-4" >
              <SelectOptions
                  label=""
                  selectAppend="transaction type"
                  labelValue="name"
                  :modelValue.sync="selectedType"
                  url="v1/transaction-types"
              />
            </div>
          </div>
          <LoadMoreCommonTable
              url="v1/get-ledger"
              :filteredData="filteredData"
              :tableHeaderValues="tableHeaderValues"
              :actions="[]"
              :deleteActions="[]"
              :mutedData="[]"
              :storageKey="storageKey"
              :externalTotalRecord="externalTotalRecord"
              :loadMore="true"
              @perPageFilterChanged="perPageFilterChanged"
              :alterResponseData="alter"
              :showPerPage="true"




          />
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

export default {
  mounted() {
    localStorage.setItem("url", "v1/get-ledger");
    this.checkDataInStore('v1/get-ledger')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      alter:{
        alter: (value) => {
          if(value){
            if(value.data){
              let temp = []
              value.data.forEach((eachArrayItem,index)=>{

                if(typeof(value.fullResponse.closingBalance) != 'undefined' && index == 0 && value.pagination.currentPage == 1){
                  this.orignalGivenClosingBalance = value.fullResponse.closingBalance
                  this.lastClosingBalance = this.orignalGivenClosingBalance

                  eachArrayItem.closing_balance = this.lastClosingBalance

                  if(parseFloat(eachArrayItem.credit_amount) != parseFloat(0)){
                    //credit
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) -  parseFloat(eachArrayItem.credit_amount)

                  }else{
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) +  parseFloat(eachArrayItem.debit_amount)
                  }

                }else{
                  eachArrayItem.closing_balance = this.lastClosingBalance

                  if(parseFloat(eachArrayItem.credit_amount) != parseFloat(0)){
                    //credit
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) -  parseFloat(eachArrayItem.credit_amount)

                  }else{
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) +  parseFloat(eachArrayItem.debit_amount)
                  }


                }


                temp.push(eachArrayItem)
              })
              value.data = temp
            }
          }

          return value
        }
      },
      orignalGivenClosingBalance:0,
      lastClosingBalance:0,
      externalTotalRecord: "",
      storageKey: "account-ledger",
      accountId: null,
      selectdValet: null,
      filteredData:{userAccountId : parseInt(this.$route.params.id) },
      valetData: [],
      tableHeaderValues: [
        {
          title: 'Transaction ID',
          valueKey: 'transaction.uuid',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary" style="cursor: pointer" title="Click For Details">${value}</span>`


            return html


          },
        },
        {
          title: 'Debit Amount',
          valueKey: 'debit_amount',
          html: true,
          alter:  (value) => {
            var html = ''
            html = `<span style="font-size: larger" class=" font-weight-bolder text-danger">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</span>`
            if ((value / 100) == 0) {
              html = `<span style="font-size: larger" class=" font-weight-bolder text-danger">-</span>`
            }

            return html

          }
        },
        {
          title: 'Credit Amount',
          valueKey: 'credit_amount',
          html: true,
          alter:  (value) => {
            var html = ''
            html = `<span style="font-size: larger" class=" font-weight-bolder text-success">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</span>`
            if ((value / 100) == 0) {
              html = `<span style="font-size: larger" class=" font-weight-bolder text-success">-</span>`
            }
            return html

          }
        },
        {
          title: 'Closing Balance',
          valueKey: 'closing_balance',
          alter:  (value) => {
            return this.modifyAmount(parseFloat(value/100).toFixed(this.amountDecimalPlaces))
          }
        },
        {
          title: 'Currency',
          valueKey: 'transaction.currency.code',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-glow badge-warning">${value}</a>`

            return html


          }
        },
        {
          title: 'Transaction Type',
          valueKey: 'transaction_type.name',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <span class="badge light badge-primary">
														${value}
													</span>`

            return html


          }
        },
        {
          title: 'Transaction Time/Date',
          titleHtml: `<br> <span class="text-warning font-weight-bolder">
														(Showing In GMT)
													</span>`,
          valueKey: 'created_at',
          alter: (value) => {
            return new Date(value).toISOString().slice(0, 16).replace('T', ' ')
          }
        },
      ],
      actions: [],
      selectedType: null,
    }
  },
  methods: {
    perPageFilterChanged(){
      this.lastClosingBalance = this.orignalGivenClosingBalance
    },
  },
  watch:{
    selectedType(val){
      if(val){
        this.filteredData = {
          userAccountId : parseInt(this.$route.params.id),
          transactionTypeId: val.id
        }
      }else{
        this.filteredData = {userAccountId : parseInt(this.$route.params.id) }
      }

    }
  }

}
</script>

